import { render, staticRenderFns } from "./CustomViewPDF.vue?vue&type=template&id=01b642de&"
import script from "./CustomViewPDF.vue?vue&type=script&lang=ts&"
export * from "./CustomViewPDF.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports